import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [resetMode, setResetMode] = useState(false)
  const [resetSent, setResetSent] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)

  const handleLogin = async () => {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  const handleReset = async () => {
    if (!email.trim()) { setError('Enter your email address above first.'); return }
    setResetLoading(true)
    setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim())
    if (error) setError(error.message)
    else setResetSent(true)
    setResetLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6f4', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 360, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/spard_logo.png" alt="Spa Road" style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', marginBottom: 12 }} onError={e => e.target.style.display = 'none'} />
          <div style={{ fontWeight: 700, fontSize: 20, color: '#1a3a2a' }}>Spa Road Laundromat</div>
          <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>Taupo, NZ</div>
        </div>

        {error && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}

        {resetSent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ background: '#e8f5ee', color: '#1a6b3c', padding: '14px', borderRadius: 8, fontSize: 14, marginBottom: 20 }}>
              Password reset email sent! Check your inbox.
            </div>
            <button onClick={() => { setResetSent(false); setResetMode(false) }}
              style={{ fontSize: 13, color: '#1a6b3c', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
              Back to Sign In
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Email</label>
              <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="you@example.com"
                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', outline: 'none' }} />
            </div>

            {!resetMode && (
              <div style={{ marginBottom: 8 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Password</label>
                <div style={{ position: 'relative' }}>
                  <input value={password} onChange={e => setPassword(e.target.value)} type={showPassword ? 'text' : 'password'} placeholder="••••••••"
                    onKeyDown={e => e.key === 'Enter' && handleLogin()}
                    style={{ width: '100%', padding: '10px 40px 10px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', outline: 'none' }} />
                  <button type="button" onClick={() => setShowPassword(v => !v)}
                    style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, padding: 0, lineHeight: 1 }}>
                    {showPassword ? '🙈' : '👁'}
                  </button>
                </div>
              </div>
            )}

            <div style={{ textAlign: 'right', marginBottom: 20 }}>
              <button type="button" onClick={() => { setResetMode(v => !v); setError('') }}
                style={{ fontSize: 12, color: '#6b7280', background: 'none', border: 'none', cursor: 'pointer' }}>
                {resetMode ? 'Back to Sign In' : 'Forgot password?'}
              </button>
            </div>

            {resetMode ? (
              <button onClick={handleReset} disabled={resetLoading}
                style={{ width: '100%', padding: '12px', background: '#1a6b3c', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: resetLoading ? 0.7 : 1 }}>
                {resetLoading ? 'Sending...' : 'Send Reset Email'}
              </button>
            ) : (
              <button onClick={handleLogin} disabled={loading}
                style={{ width: '100%', padding: '12px', background: '#1a6b3c', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  )
}
